import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { WelcomePage } from './pages';
import AboutPage from './pages/AboutPage';
import AppointmentPage from './pages/AppointmentPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<WelcomePage />} />
        <Route path='/book' element={<AppointmentPage />} />
        <Route path='/about' element={<AboutPage />} />
      </Routes>
    </Router>
  );
}

export default App;
